import React from 'react';
import { Link } from 'react-router-dom';
import Typography from "@material-ui/core/Typography";
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import HomeIcon from '@material-ui/icons/Home';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    height: '80vh'
  },
  card: {
    maxWidth: 600,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  title: {
    marginBottom: theme.spacing(2),
    color: theme.palette.error.main
  },
  content: {
    marginBottom: theme.spacing(3)
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2)
  },
  button: {
    margin: theme.spacing(1)
  }
}));

const Unauthorized = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h4" component="h1" className={classes.title}>
            Access Denied
          </Typography>
          
          <Typography variant="body1" className={classes.content}>
            You don't have the necessary permissions to access this page.
            <br />
            Please contact your administrator if you believe you should have access to this page.
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default Unauthorized;